import React, { Children, cloneElement } from 'react'
import PropTypes from 'prop-types'
import {
  Listbox,
  FieldAdapter,
} from '@entrata/portals-common/lib/components/forms'
import SettingsListItem from './SettingsListItem'

import styled from '@emotion/styled'

const StyledUl = styled('ul')`
  list-style-type: none;
  margin: 16px 0;
  padding-left: 0;

  &[aria-disabled='true'] {
    opacity: 0.5;
  }
`

const validate = ({ value, required }) => {
  if (!required) return ''
  return value.length > 1 ? '' : __('This field is required')
}

const SettingsList = ({ children, ...props }) => (
  <FieldAdapter {...props} validate={validate}>
    {inputProps => (
      <Listbox allowMultiple {...inputProps}>
        {({ getInputItemProps, getWrapperProps }) => (
          <StyledUl {...getWrapperProps()}>
            {Children.map(children, child => {
              if (child.type.displayName === 'SettingsListItem') {
                const { name, ...rest } = child.props
                return cloneElement(child, getInputItemProps(name, rest))
              } else {
                return null
              }
            })}
          </StyledUl>
        )}
      </Listbox>
    )}
  </FieldAdapter>
)

SettingsList.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  element: PropTypes.string,
  name: PropTypes.string,
  onUpdate: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

SettingsList.Item = SettingsListItem

export default SettingsList
